
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { MstClaimVO } from "@/views/biz/mypage/vo/mypage.vo";
import { RelClaimProductVO } from "../order/vo/order.vo";

@Component
export default class OrderClaimInventory extends Vue {
  claims: Array<MstClaimVO> = [] as Array<MstClaimVO>;
  products: Array<RelClaimProductVO> = [] as Array<RelClaimProductVO>;

  // 주문 취소 상세 페이지로 이동
  goToOrderDetail(item: MstClaimVO) {
    let cliamType = "cancel";
    if (item.claimStatusCd.startsWith("00407")) {
      cliamType = "return";
    }

    this.$router.push({ name: "OrderClaimDetail", params: { claimType: cliamType, orderCd: item.orderCd.toString(), claimCd: item.claimCd.toString() } });
  }

  // // 다시 구매
  // repurchase(item: OrderClaimInventoryVO) {
  //   this.$router.push(`/product/${item.productCd}`);
  // }

  getClaimProductByClaimCd(claimCd: number) {
    return this.products.filter((v) => v.claimCd == claimCd);
  }

  // 초기화
  created() {
    axios.get("/mypage/order/claims").then(
      (r) => {
        this.claims = r.data.claims;
        this.products = r.data.products;
      },
      (err) => {
        console.error(err);
      }
    );
  }
}
